import {Component, OnInit} from '@angular/core';
import {EntitySelectorComponent} from '../entity-selector/entity-selector.component';
import {Group} from '../../models/group';
import {ApiService} from '../../services/api/api.service';
import {GroupsService} from '../../services/groups/groups.service';
import {EntitiesService} from '../../services/entities/entities.service';
import {LocationsService} from '../../services/locations/locations.service';
import {VineaLocation} from '../../models/vinea-location';
import {Builder} from '../../models/builder';
import {ApiVirtualizationLayerService} from '../../services/api-virtualization-layer/api-virtualization-layer.service'

// Usage:
//   <ngx-message-entity-selector
//   *ngIf="massMessageStep == 0 && !sending"
//     [entities]="childEntities"
//   (onCancel)="closeModal($event)"
//   (onContinue)="createEntry($event)"
//   >
//   </ngx-message-entity-selector>

@Component({
  selector:    'ngx-message-entity-selector',
  templateUrl: './message-entity-selector.component.html',
  styleUrls:   ['./message-entity-selector.component.scss'],
})
export class MessageEntitySelectorComponent extends EntitySelectorComponent implements OnInit {
  public groups: Array<Group>            = [];
  public selectedGroupId: number         = 0;
  public selectedLocationId: number      = 0;
  public categories: Array<any>          = [];
  public locations: Array<VineaLocation> = [];
  public minAge: number                  = null;
  public maxAge: number                  = null;

  public entitiesLoading: boolean  = false;
  public locationsLoading: boolean = true;
  public groupsLoading: boolean    = true;

  constructor(
    private api: ApiService,
    private apiv: ApiVirtualizationLayerService,
    private groupsService: GroupsService,
    private entitiesService: EntitiesService,
    private locationsService: LocationsService,
  ) {
    super();
  }

  ngOnInit() {
    const vm = this;

    // vm.loadLocations();
    // vm.loadGroups();

    this.apiv.getAllEntities().subscribe(entities => {
      this.selectableEntities = entities;
    });

    this.api.get('v1/entities/available-filters').then(data => {
      vm.categories = data['group_types'];
    });

    super.ngOnInit();
  }

  loadGroups() {
    const vm         = this;
    vm.groupsLoading = true;
    vm.groupsService.everything().then(data => {
      vm.groups        = data;
      vm.groupsLoading = false;
    });
  }

  loadLocations() {
    const vm = this;
    vm.locationsLoading = true;
    vm.locationsService.everything().then(data => {
      vm.locations        = data;
      vm.locationsLoading = false;
    });
  }

  onNewGroupSelected() {
    const vm = this;
    if (this.selectedGroupId === 0) {
      vm.selectableEntities = vm.entities.slice(0);
    } else {
      this.groupsService.getEntitiesAll(this.selectedGroupId).then(data => {
        vm.selectableEntities = data;
      });
    }
    this.selectedEntities = [];
  }

  onFilterChange() {
    const vm = this;

    const builder = new Builder();
    builder.addFilter('location_id', [vm.selectedLocationId]);
    // this.groupsService.everything(builder).then(data => {
    //   this.groups = data;
    // });
    //
    // if (this.selectedGroupId !== 0) {
    //   vm.entitiesLoading = true;
    //   this.groupsService.getFilteredCategories(this.selectedGroupId, vm.selectedCategory,
    //     this.minAge, this.maxAge).then(data => {
    //     vm.selectableEntities = data;
    //     vm.selectedEntities   = [];
    //     vm.entitiesLoading    = false;
    //   });
    // } else {
    //   vm.entitiesLoading = true;
    //   this.entitiesService.everything(vm.selectedCategory, this.minAge, this.maxAge).then(data => {
    //     vm.selectableEntities = data;
    //     vm.selectedEntities   = [];
    //     vm.entitiesLoading    = false;
    //   });
    // }
  }
}
